export default "__VITE_ASSET__DGmyi56U__"